import script from "./RawScaledImage.vue?vue&type=script&setup=true&lang=js"
export * from "./RawScaledImage.vue?vue&type=script&setup=true&lang=js"

import "./RawScaledImage.vue?vue&type=style&index=0&id=6d4a4f32&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d4a4f32"]])

export default __exports__